import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import Header from "../../AdminComponents/Header";
import { useDispatch } from "react-redux";
import { AddPopularLocation } from "../../../../context/Slice/VendorManagementSlice";

const CreatePopularLocation = ({ handleFormClose, refreshLocationList }) => {
  const dispatch = useDispatch();

  const validationSchema = yup.object({
    LocationName: yup.string().required("Location Name is required"),
    Description: yup.string().required("Description is required"),
    Images: yup.array().min(1, "At least one image is required"),
  });

  const formik = useFormik({
    initialValues: {
      LocationName: "",
      Description: "",
      Images: [],
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // Construct image payload
      const imagePayload = values.Images.map((file) => ({
        fieldname: "Images",
        originalname: file.name,
        encoding: "7bit",
        mimetype: file.type,
        destination: "/uploads",
        filename: file.name,
        path: `/uploads/${file.name}`,
        size: file.size,
      }));

      const payload = {
        LocationName: values.LocationName,
        Descriptions: values.Description,
        Images: JSON.stringify(imagePayload),
      };

      const response = await dispatch(AddPopularLocation(payload));
      if (response.payload) {
        console.log("response", response.payload);
        refreshLocationList();
        handleFormClose();
      } else {
        console.error("Failed to add service location");
      }
    },
  });

  // Handle multiple file input
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files).slice(0, 3); // Limit to 3 images
    formik.setFieldValue("Images", files);
  };

  return (
    <Box m="20px">
      <Header title="Add New Location" subtitle="Add a new location" />

      <form autoComplete="off" onSubmit={formik.handleSubmit}>
        <Box
          display="grid"
          gap="30px"
          gridTemplateColumns="repeat(2, minmax(0, 1fr))"
        >
          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Location Name"
            name="LocationName"
            value={formik.values.LocationName}
            onChange={formik.handleChange}
            error={
              formik.touched.LocationName && Boolean(formik.errors.LocationName)
            }
            helperText={
              formik.touched.LocationName && formik.errors.LocationName
            }
            InputLabelProps={{ style: { fontSize: 17 } }}
            inputProps={{ style: { fontSize: 20 } }}
            sx={{ gridColumn: "span 1" }}
          />

          <TextField
            fullWidth
            variant="filled"
            type="file"
            label="Upload Images"
            inputProps={{
              multiple: true,
              accept: "image/*",
              style: { fontSize: 15, marginTop: "9px" },
            }}
            InputLabelProps={{ shrink: true, style: { fontSize: 15 } }}
            onChange={handleFileChange}
            error={formik.touched.Images && Boolean(formik.errors.Images)}
            helperText={formik.touched.Images && formik.errors.Images}
          />

          <TextField
            fullWidth
            variant="filled"
            type="text"
            label="Description"
            name="Description"
            value={formik.values.Description}
            onChange={formik.handleChange}
            error={
              formik.touched.Description && Boolean(formik.errors.Description)
            }
            helperText={formik.touched.Description && formik.errors.Description}
            multiline
            rows={7}
            InputLabelProps={{ style: { fontSize: 17 } }}
            inputProps={{ style: { fontSize: 12 , marginTop:"15px"} }}
            sx={{width:"142%"}}
          />
        </Box>

        <Box display="flex" justifyContent="center" mt="20px">
          <Button
            type="submit"
            variant="contained"
            className="primary fs-4"
            sx={{ mr: 2 }}
          >
            Add
          </Button>
          <Button
            type="button"
            variant="contained"
            className="primary fs-4"
            onClick={handleFormClose}
          >
            Back
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default CreatePopularLocation;
